import api from "./client";

/* Marketing → Audiences — bound to crm_backend app `audiences`.
   Contract of record: docs/WEB_VISIBILITY_CONTRACTS_2026-09-22.md §5 (crm_backend).
   Every export is gated on a recorded owner authorization
   (partner_referral.CrossTenantAuthorization, purpose=audience_export) and
   ledgered as an AudienceExport row. The screen renders an honest "not
   deployed yet" state on 404 — never sample data. */

const BASE = "/marketing/audiences";

// GET /api/marketing/audiences/segments/ → { segments: [{key,label,definition,sendable,exclusions:{reason:n}}],
//   networks: [{key,label,connected,push_available,reason}], policy: {status,text} }
export const getSegments = () => api.get(`${BASE}/segments/`);

// POST /api/marketing/audiences/authorize/ { segment_key | filters, network, attestation, note? }
export const authorize = (body) => api.post(`${BASE}/authorize/`, body);

// GET /api/marketing/audiences/authorizations/ → { authorizations: [...] }
export const listAuthorizations = () => api.get(`${BASE}/authorizations/`);

// POST /api/marketing/audiences/export/ { segment_key | filters, network, mode: "file" | "push" }
// file mode answers with a CSV attachment; push mode answers JSON.
export const exportAudience = ({ mode = "file", ...body }) =>
  api.post(
    `${BASE}/export/`,
    { ...body, mode },
    mode === "file" ? { responseType: "blob" } : undefined
  );

// GET /api/marketing/audiences/exports/ → { exports: [...], last_by_network: {google:{...}, meta:{...}, openai:{...}} }
export const listExports = () => api.get(`${BASE}/exports/`);

// Filename from a Content-Disposition header, with a safe fallback.
export const filenameFromDisposition = (headers = {}, fallback = "audience.csv") => {
  const raw = headers["content-disposition"] || headers["Content-Disposition"] || "";
  const star = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(raw);
  if (star?.[1]) {
    try { return decodeURIComponent(star[1].trim().replace(/^"|"$/g, "")); } catch { /* fall through */ }
  }
  const plain = /filename="?([^";]+)"?/i.exec(raw);
  return plain?.[1]?.trim() || fallback;
};

// A blob error body (file mode) still carries the backend's reason string — surface it.
export const readBlobError = async (error) => {
  // client.js normalizes errors: .payload is the response body, .original the axios error.
  const data = error?.payload ?? error?.original?.response?.data ?? error?.response?.data;
  if (data instanceof Blob) {
    try {
      const text = await data.text();
      const parsed = JSON.parse(text);
      return parsed?.detail || parsed?.error || parsed?.code || text;
    } catch {
      return error?.message || "Export failed";
    }
  }
  return data?.detail || data?.error || data?.code || error?.message || "Export failed";
};
